export const state = () => ({
	statusCode: 404,
});

export const mutations = {
	setStatusCode(state, payload) {
		state.statusCode = payload;
	},
};
